import axios from 'axios';
import AutenticationService from '../../authservice.js';
import AccessiService from '../Accessi/AccessiApi.js';
class LoginSrv {
  //{ nome: 'claudio', password: 'manno' }

  getLogin = (dati) => {
    // AutenticationService.saveUserInfo(dati.userid, dati.password);
    const qs = require('qs');
    //const url = 'https://192.168.1.26:8443/login/';
    const url = AccessiService.getUrl() + '/login/';
    return axios.post(url, qs.stringify(dati));
  };

  getLoginConBasic = (dati) => {
    let BasicAuthHeader =
      'Basic ' + window.btoa(dati.userid + ':' + dati.password);
    const qs = require('qs');
    //const url = 'https://192.168.1.26:8443/login/';
    const url = AccessiService.getUrl() + '/login/';
    return axios.post(url, qs.stringify(dati), {
      headers: {
        authorization: BasicAuthHeader,
      },
    });
  };
}

export default new LoginSrv();
